import {
  Shield, ConciergeBell, Sparkles, Wrench, Trash2, SquareParking, Flame,
  Building2, Home, Users, HardHat, ShoppingBag, GraduationCap, HeartPulse, Landmark,
} from "lucide-react";

export const company = {
  name: "Total Facilities Services",
  short: "TFS",
  tagline: "Nationwide facilities management, delivered with precision.",
  phone: "0204 531 8240",
  email: "mail@tfservices.co.uk",
  address: "21a-21b George Street, Croydon, Surrey, CR0 1LA",
  reg: "Company No. 15404423",
  vat: "VAT No. 481003428",
  coverage: "Operating UK-wide, open 24/7",
  whatsapp: "447523910711",
};

export const socials = [
  { label: "Instagram", href: "https://www.instagram.com/totalfacilitiesservices", icon: "instagram" },
  { label: "Facebook", href: "https://www.facebook.com/totalfacilitiesservices", icon: "facebook" },
];

export const IMAGES = {
  heroBuilding: "https://images.unsplash.com/photo-1581279813180-4dddc1008167?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  security: "https://static.prod-images.emergentagent.com/jobs/ed3b73be-d897-4fc0-b204-9a322532f385/images/13fd698baa3bcd825d7b44a26959ebde5bed4ffac3c64c0027a91c8f7616e9e2.jpeg",
  cleaning: "https://images.pexels.com/photos/10567236/pexels-photo-10567236.jpeg",
  maintenance: "https://images.pexels.com/photos/8293639/pexels-photo-8293639.jpeg?auto=compress&cs=tinysrgb&w=1400",
  commercial: "https://images.unsplash.com/photo-1549483249-f0b359d1e289?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  residential: "https://images.unsplash.com/photo-1738432552052-4e983f48e13b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  construction: "https://images.unsplash.com/photo-1740504942599-897232a3f706?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  skyline: "https://images.unsplash.com/photo-1654457949106-d4f818c49536?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  office: "https://images.unsplash.com/photo-1549637642-90187f64f420?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  concierge: "https://static.prod-images.emergentagent.com/jobs/ed3b73be-d897-4fc0-b204-9a322532f385/images/e4410b5c2d13a82481580a1bd81aa1fc43e59c1c170776dcba4b5823025d4da5.jpeg",
  waste: "https://static.prod-images.emergentagent.com/jobs/ed3b73be-d897-4fc0-b204-9a322532f385/images/082a8a521e1446337e09a33bfcc82c47340f1272f7ad3cf96667448e7edb59eb.jpeg",
  fire: "https://images.unsplash.com/photo-1653353436174-a8e724190fd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const services = [
  {
    slug: "security-mobile-patrols",
    title: "Security & Mobile Patrols",
    short: "Manned guarding, mobile patrols and rapid response for total peace of mind.",
    icon: Shield,
    image: IMAGES.security,
    points: [
      "SIA-licensed security officers",
      "Scheduled and random mobile patrols",
      "Keyholding and alarm response",
      "24/7 control room and reporting",
    ],
  },
  {
    slug: "concierge-front-of-house",
    title: "Concierge & Front-of-House",
    short: "Professional, welcoming reception and concierge teams for your building.",
    icon: ConciergeBell,
    image: IMAGES.concierge,
    points: [
      "Corporate reception staff",
      "Residential concierge services",
      "Visitor and access management",
      "Parcel and post handling",
    ],
  },
  {
    slug: "commercial-cleaning",
    title: "Commercial Cleaning",
    short: "Daily, deep and specialist cleaning that keeps every space immaculate.",
    icon: Sparkles,
    image: IMAGES.cleaning,
    points: [
      "Daily office and communal cleaning",
      "Deep and periodic cleans",
      "Window and facade cleaning",
      "Washroom and consumables management",
    ],
  },
  {
    slug: "reactive-planned-maintenance",
    title: "Reactive & Planned Maintenance",
    short: "Keeping buildings safe, compliant and fully operational around the clock.",
    icon: Wrench,
    image: IMAGES.maintenance,
    points: [
      "Planned preventative maintenance (PPM)",
      "24/7 reactive callouts",
      "M&E, plumbing and electrical",
      "Statutory compliance checks",
    ],
  },
  {
    slug: "waste-removal",
    title: "Waste Removal & Bulky Collections",
    short: "Responsible waste management and bulky waste clearance with full duty of care.",
    icon: Trash2,
    image: IMAGES.waste,
    points: [
      "Scheduled waste collection",
      "Bulky and fly-tip clearance",
      "Recycling and segregation",
      "Waste transfer documentation",
    ],
  },
  {
    slug: "parking-management",
    title: "Parking Management & Enforcement",
    short: "Fair, compliant parking control that protects your site and tenants.",
    icon: SquareParking,
    image: IMAGES.residential,
    points: [
      "ANPR and permit systems",
      "Patrols and enforcement",
      "Signage and audits",
      "IPC/BPA-compliant processes",
    ],
  },
  {
    slug: "fire-wardens-waking-watch",
    title: "Fire Wardens & Waking Watch",
    short: "Trained fire safety personnel and interim waking watch cover you can trust.",
    icon: Flame,
    image: IMAGES.fire,
    points: [
      "Trained fire wardens",
      "Interim waking watch cover",
      "Evacuation management",
      "Fire safety logging and reporting",
    ],
  },
];

export const reasons = [
  {
    n: "01",
    title: "One partner, every service",
    body: "Consolidate security, cleaning, maintenance and more under a single accountable contract with one point of contact.",
  },
  {
    n: "02",
    title: "Genuine UK-wide coverage",
    body: "A national network of vetted, trained personnel means consistent standards whether you have one site or one hundred.",
  },
  {
    n: "03",
    title: "24/7 operations centre",
    body: "Our control room never sleeps. Live reporting, rapid response and complete visibility of every site, every hour.",
  },
  {
    n: "04",
    title: "Compliance without compromise",
    body: "Fully accredited and audited processes keep you safe, legal and inspection-ready at all times.",
  },
];

export const sectors = [
  { title: "Commercial Properties", icon: Building2, blurb: "Offices, business parks and mixed-use estates." },
  { title: "Residential Developments", icon: Home, blurb: "Build-to-rent, blocks and gated communities." },
  { title: "Managing Agents", icon: Users, blurb: "Reliable delivery across diverse portfolios." },
  { title: "Construction Sites", icon: HardHat, blurb: "Site security, cleaning and fire safety cover." },
  { title: "Retail & Leisure", icon: ShoppingBag, blurb: "Shopping centres, hospitality and venues." },
  { title: "Education", icon: GraduationCap, blurb: "Schools, colleges and university campuses." },
  { title: "Healthcare", icon: HeartPulse, blurb: "Clinics, care homes and medical facilities." },
  { title: "Public Sector", icon: Landmark, blurb: "Councils, civic buildings and infrastructure." },
];

export const accreditations = [
  { name: "SafeContractor Approved", note: "Health & Safety accredited supplier" },
  { name: "Waste Carrier Licence", note: "Environment Agency registered" },
  { name: "IPC Approved Operator", note: "International Parking Community" },
  { name: "SIA Licensed Personnel", note: "Security Industry Authority" },
  { name: "Open 24/7", note: "Round-the-clock operations" },
  { name: "Fully Insured", note: "Comprehensive liability cover" },
];

export const testimonials = [
  {
    quote:
      "TFS took over five sites from three different suppliers and standardised everything within a month. Response times are outstanding and reporting is genuinely useful.",
    name: "Sarah Whitfield",
    role: "Head of Property, Meridian Estates",
  },
  {
    quote:
      "The waking watch and fire warden cover was mobilised in under 24 hours. Professional, licensed and reassuring throughout a difficult period.",
    name: "James Okafor",
    role: "Managing Agent, Crown Residential",
  },
  {
    quote:
      "One contract, one invoice, one point of contact across security, cleaning and maintenance. It has transformed how we run our commercial portfolio.",
    name: "Priya Nair",
    role: "Facilities Director, Northgate Group",
  },
];

export const stats = [
  { value: "24/7", label: "Operations centre" },
  { value: "500+", label: "Sites managed" },
  { value: "1,200+", label: "Vetted personnel" },
  { value: "98%", label: "Contract retention" },
];
